import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, MainHeading } from '../../globalStyles';
import { HeroVideo, HeroSection, HeroText, ButtonWrapper } from './HeroStyles';

const Hero = () => {
	return (
		<HeroSection>
			<HeroVideo src="./assets/miochero.jpg"/>
			<Container>
				<MainHeading>Vaš odvjetnički ured</MainHeading>
				<HeroText>
					Cijenimo Vaše povjerenje
				</HeroText>
				<ButtonWrapper>
					<Link to="signup">
					<Button>Kontaktiraj
					</Button>
					</Link>
					<Button>Saznaj više
					</Button>
				</ButtonWrapper>
			</Container>
		</HeroSection>
	);
};

export default Hero;
